export default __webpack_public_path__ + "static/media/b33b5a79eab86e77faabd9148dfab6eb1598906315011.1fbefda2.webp";